export class UserFinancialCommunityAssoc {
    userFinancialCommunityAssocId: number;
    userGuid: string;
    financialCommunityId: number;
}